import UploadTaxReturn from "../Common/tax-id-theft/upload-tax-return";

function UploadTaxReturnPage() {
  return (
    <>
      <UploadTaxReturn />
    </>
  );
}

export default UploadTaxReturnPage;
